<section>

<app-filter-panel (selectedFilterValuesEvent) = "onFilterChange($event)"></app-filter-panel>

<c-row class="mt-3">
    <!-- <c-col>
        Filters applied: <c-badge class="badge bg-primary ng-star-inserted"> This Year </c-badge>
    </c-col> -->
</c-row>
<c-row class="mt-3">

    <c-col>
        <div class="card">
            <div class="card-header">
                <h4 class="card-header__heading">Top Unused Vehicle Count by Day</h4>
            </div>
            <div class="card-body">
                <c-smart-table #smartTable="cSmartTable" [columnFilter]="true" [columnSorter]="true" [itemsPerPage]="15" [columns]="columns"
                [items]="vehicleData" [tableProps]="{ hover: true, striped: true, responsive: true }"
                activePage="1" header pagination>

                <ng-template
                cTemplateId="tableData"
                let-columnName="columnName"
                let-item="item"
                let-tdContent="tdContent"
              >
                <td
                  [ngClass]="smartTable.getTableDataCellClass(item, columnName)"
                >
                  @switch (columnName) {
                    @case ('snapshot_date')
                    {
                        {{tdContent ? (tdContent | date : 'dd/M/yyyy ') : '-'}}
                    }
                    @case ('view') {
                        <a class="link" cOffcanvasToggle="OffcanvasStart" (click)="navigateToDepotSummary(tdContent)">View</a>
                    }
                    @default {
                      {{ tdContent ? tdContent : '-'}}
                    }
                }
                </td>
              </ng-template>

                </c-smart-table>
            </div>
           </div>
    
    </c-col>
</c-row>
</section>
<c-offcanvas
  placement="end"
  id="OffcanvasStart"
>
  <c-offcanvas-header>
    <h5 cOffcanvasTitle>Top Unused Vehicle Count</h5>
    <button
      cButtonClose
      class="text-reset ms-auto"
      cOffcanvasToggle="OffcanvasStart"
      aria-label="Close"
    ></button>
  </c-offcanvas-header>
  <c-offcanvas-body>

    <div class="card">
      <!-- <div class="card-header">
          <h4 class="card-header__heading">Top Unused Vehicle Count</h4>

      </div> -->

      <div class="card-body">
          <c-smart-table #smartTable="cSmartTable" [columnFilter]="true" [columnSorter]="true" [itemsPerPage]="20" [columns]="topUnsedColumns"
          [items]="vehicleConsecutiveDaysData" [tableProps]="{ hover: true, striped: true, responsive: true }"
          activePage="1" header pagination  [itemsPerPageSelect]="true"
          [loading]="isCanvasLoading"
          >

          </c-smart-table>
      </div>
     </div>


  </c-offcanvas-body>
</c-offcanvas>